import { render, staticRenderFns } from "./FixSkd.vue?vue&type=template&id=6d523f99"
import script from "./FixSkd.vue?vue&type=script&lang=js"
export * from "./FixSkd.vue?vue&type=script&lang=js"
import style0 from "./FixSkd.vue?vue&type=style&index=0&id=6d523f99&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports